// extracted by mini-css-extract-plugin
export default {"wrapperSelect":"SeminarianSelection_wrapperSelect__GAwJ9","select":"SeminarianSelection_select__Iuqkp"};